console.log("LL")

const id = localStorage.getItem("Sb_UserId")


if( !id){
    if(window.location.pathname!='/'){
      window.location.href='/'
    }
 

}else{
    if(window.location.pathname==='/'){
        window.location.href='/home'
    }
}


